import { branch, renderNothing } from 'recompose'

import { componentSelector, brandLogosSelector } from 'wordpress/selectors'
import { withRouter, Route } from 'i18n/utils'
import { GRID_BREAKPOINT_MD } from 'shared/breakpoints'
import Subscribe from 'home/components/Subscribe'

import MediaQuery from 'react-responsive'

import Footer from './Footer'
import FooterResponsive from './FooterResponsive'

import styles from '../styles/footer.module.scss'

const FooterContainer = ({ footerConfig, brandLogos }) => {
    const { columns = [] } = footerConfig

    return (
        <div className={styles.footer}>
            <Route exact path="/">
                <Subscribe layout />
            </Route>
            <MediaQuery minWidth={GRID_BREAKPOINT_MD}>
                <Footer columns={columns} brandLogo={brandLogos?.footerLogo} />
            </MediaQuery>
            <MediaQuery maxWidth={GRID_BREAKPOINT_MD - 1}>
                <FooterResponsive columns={columns} brandLogo={brandLogos?.footerLogo} />
            </MediaQuery>
        </div>
    )
}
FooterContainer.propTypes = {
    columns: PropTypes.array,
}

export const footerConfigurationSelector = componentSelector('footer')
const mapStateToProps = state => ({
    footerConfig: footerConfigurationSelector(state),
    brandLogos: brandLogosSelector(state),
})

export default compose(
    withRouter,
    branch(({ location: { pathname } }) => /^\/map/.test(pathname), renderNothing),
    connect(mapStateToProps)
)(FooterContainer)
